import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MessageService } from '../../../../services/message.service'
import { MasterService } from '../../../../services/master.service'
import { StoreService } from '../../../../services/store.service'
import { SecurityService } from '../../../../services/security.service'
import * as languageLibrary from '../../../../services/language'

@Component({
    selector: 'app-corporations',
    templateUrl: './corporations.component.html',
    styleUrls: ['./corporations.component.scss'],
    standalone: false
})
export class CorporationsComponent implements OnInit {
    /*
    * Variables
    */
    
    // save the language
    protected language: string = localStorage.getItem('language') ? localStorage.getItem('language') : 'EN'
    
    // set all words
    protected words = languageLibrary.language
    
    // save all data by type
    private data: Object | null = null
    
    // define the contact type
    protected type: string = ''
    
    // table headers
    private headers: Object[] = [
        { name: 'Name', param: 'companyName' },
        { name: 'Dealer Number', param: 'dealerNumber' },
        { name: 'Address', param: 'address' },
        { name: 'Phone', param: 'phone' },
        { name: 'Doing-Business-As Name', param: 'dba' },
        { name: 'Status', param: 'status' }]

    protected corporation: any = {};

    // define if is loading
    protected loading: boolean = false
    
    // define if is adding
    protected adding: boolean = false
    
    // define item Selected
    protected itemSelected: any = {}
    
    // expanded/collapsed
    private expanded = true
    
    protected selectedDealershipId: number;
    
    protected selectedLotId: number;

    /*
    * life cycles
    */
    constructor(private route: ActivatedRoute, public store: StoreService, private router: Router, private ms: MessageService, private master: MasterService, public security: SecurityService) { }

    ngOnInit() {
        this.type = this.route.snapshot.params['type']
        this.getCorporationEntities()
    }

    /*
  * Functions
  */
    // list of company entities
    private getCorporationEntities = () => {
        if (this.security.notPermitted('corporation setup', 'corporate list', 'view')) {
            return
        }

        this.master.get(`corporations`, res => {
            if (!res) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }

            this.corporation = res.data.corporate
            this.reloadLots()
        })
    }
    // add new dealership
    protected createDealership = (e: Event): void => {
        e.stopPropagation()
        e.preventDefault()

        if (this.security.notPermitted('corporation setup', 'dealership detail', 'add')) {
            return
        }

        this.router.navigateByUrl(`/settings/corporations/dealership/add`)
        return
    }

    // add new lot
    protected createLot = (e: Event, dealershipId: number): void => {
        e.stopPropagation()
        e.preventDefault()

        if (this.security.notPermitted('corporation setup', 'lot detail', 'add')) {
            return
        }

        this.router.navigateByUrl(`/settings/corporations/lot/add?dealer=${dealershipId}`);
        return
    }

    // read dealership
    protected editCorp = (e: Event, id: number): void => {
        e.stopPropagation()
        e.preventDefault()
        
        if (this.security.notPermitted('corporation setup', 'corporate detail', 'update')) {
            return
        }

        this.router.navigateByUrl(`/settings/corporations/${id}`)
        return
    }

    // read dealership
    protected editDealer = (e: Event, id: number): void => {
        e.stopPropagation()
        e.preventDefault()

        if (this.security.notPermitted('corporation setup', 'dealership detail', 'update')) {
            return
        }

        this.router.navigateByUrl(`/settings/corporations/dealership/${id}`)
        return
    }

    // read lot
    protected editLot = (e: Event, id: number): void => {
        e.stopPropagation()
        e.preventDefault()

        if (this.security.notPermitted('corporation setup', 'lot detail', 'update')) {
            return
        }

        this.router.navigateByUrl(`/settings/corporations/lot/${id}`);
        return
    }

    protected deleteDealership = (): void => {
        if (this.security.notPermitted('corporation setup', 'dealership detail', 'delete')) {
            return
        }

        this.master.discard(`dealerships/${this.selectedDealershipId}`, res => {
            if (!res) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }
            this.selectedDealershipId = null
            document.getElementById('btn-close-modal-deleteDealership').click()
            this.getCorporationEntities()
        })
    }

    protected deleteLot = (): void => {
        if (this.security.notPermitted('corporation setup', 'lot detail', 'delete')) {
            return
        }

        this.master.discard(`lots/${this.selectedLotId}`, res => {
            if (!res) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }
            this.selectedLotId = null
            document.getElementById('btn-close-modal-deleteLot').click()
            this.getCorporationEntities()
        })
    }

    private restoreDealership = (): void => { }
    private restoreLot = (): void => { }

    protected checkDealershipRelationships = (id: number): void => {
        this.selectedDealershipId = id
        this.master.get(`dealerships/${id}/relationships`, res => {
            if (!res) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.data.error == 'Error: The dealership has relationships') {
                (document.getElementById('btn-deactivate-dealership-modal') as HTMLButtonElement).click();
                return
            }
            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }
            (document.getElementById('btn-deleteDealership-modal') as HTMLButtonElement).click();
        })
    }

    protected setLotId(lotId){
        this.selectedLotId = lotId
    }
    protected setDealershipId(dealershipId){
        this.selectedDealershipId = dealershipId
    }

    protected checkLotRelationships = (id: number): void => {
        this.selectedLotId = id
        this.master.get(`lots/${id}/relationships`, res => {
            if (!res) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.data.error == 'Error: The lot has relationships') {
                (document.getElementById('btn-deactivate-lot-modal') as HTMLButtonElement).click();
                return
            }
            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }

            (document.getElementById('btn-deleteLot-modal') as HTMLButtonElement).click();
        })
    }

    private restore = () => {
        (document.getElementById('btn-active-modal') as HTMLButtonElement).click();
    }

    // select a item
    protected selectItem = (entity: string, id: number, active: string): void => {
        if (!active)
            this.itemSelected = { entity: entity, entityId: id, type: active }
        this.itemSelected['type'] == 'Active' ? this.itemSelected['type'] = 'Disabled' : this.itemSelected['type'] = 'Active'
        if (active == 'Active') {
            // ? only active
            this.master.post('checkEntityRealtionship', { entity: entity, entityId: id }, res => {
                if (res) {
                    if (res.status == 200) {
                        // ? normal
                        (document.getElementById('btn-delete-modal') as HTMLButtonElement).click();

                    } else {
                        // ! important
                        (document.getElementById('btn-deactivate-modal') as HTMLButtonElement).click();

                    }
                } else {
                    // api no responde
                    this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] });
                }
            })
        } else {
            // ? only disabled
            (document.getElementById('btn-active-modal') as HTMLButtonElement).click();

        }

    }

    /*
  ! DELETE functions
  */
    protected deactivateLot = (): void => {
        this.master.patch(`lots/${this.selectedLotId}/deactivate`, null ,res => {
            if (!res) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }

            this.selectedLotId = null
            document.getElementById('btn-close-modal-deactivate').click()
            this.getCorporationEntities()
        })
    }

    protected activateLot = (): void => {
        this.master.patch(`lots/${this.selectedLotId}/activate`, null ,res => {
            if (!res) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }

            this.selectedLotId = null
            document.getElementById('btn-close-modal-activate-lot').click()
            this.getCorporationEntities()
        })
    }
    
    protected deactivateDealership = (): void => {
        this.master.patch(`dealerships/${this.selectedDealershipId}/deactivate`, null ,res => {
            if (!res) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }

            this.selectedDealershipId = null
            document.getElementById('btn-close-modal-deactivate-dealership').click()
            this.getCorporationEntities()
        })
    }
    
    protected activateDealership = (): void => {
        this.master.patch(`dealerships/${this.selectedDealershipId}/activate`, null ,res => {
            if (!res) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }

            this.selectedDealershipId = null
            document.getElementById('btn-close-modal-activate-dealership').click()
            this.getCorporationEntities()
        })
    }

    private reloadLots = (): void => {
        this.master.get('users/account', res => {
            if (!res || !res.data) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }

            // send permissions for all components
            this.ms.channelComponents$.emit({ message: 'updateLotList', section: 'setup', value: res['data']['user'].lots })
        })
    }

    // todo: listen to output of navbar
    protected listenerNav = (e): void => {
        switch (e['message']) {
            case 'changeLanguage':
                this.language = e['value']
                break;
            case 'setPermissions':
                this.getCorporationEntities()
                break
            default:
                break;
        }
    }

}
